import { assign, createMachine } from "xstate";
import { downloadDocument } from "../usecases/downloadDocument";

interface Context {
    error?: any;
    documentId?: string;
}

export enum DocumentDownloadMachineState {
    Idle = "idle",
    Loading = "loading",
}

export const documentDownloadMachine = createMachine<Context>({
    id: "documentDownloadMachine",
    initial: DocumentDownloadMachineState.Idle,
    context: {
        error: undefined,
        documentId: undefined,
    },
    states: {
        [DocumentDownloadMachineState.Idle]: {
            on: {
                DOWNLOAD: {
                    target: DocumentDownloadMachineState.Loading,
                    actions: assign({
                        documentId: (_, event) => event.documentId,
                    }),
                },
            },
        },
        [DocumentDownloadMachineState.Loading]: {
            invoke: {
                src: (_, event) =>
                    downloadDocument(event.token, event.document),
                onDone: {
                    target: DocumentDownloadMachineState.Idle,
                    actions: assign({
                        documentId: (_) => undefined,
                    }),
                },
                onError: {
                    target: DocumentDownloadMachineState.Idle,
                    actions: [
                        assign({
                            error: (_, event) => event.data,
                            documentId: (_) => undefined,
                        }),
                        "notifyErrorDownloadingDocument",
                    ],
                },
            },
        },
    },
});
